import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController } from 'ionic-angular';
import { ConsumptionChartPage } from '../consumption-chart/consumption-chart';
import { MeterReadingPage } from '../meter-reading/meter-reading';
import { MeterProvider } from '../../providers/meter/meter';
import { ExportMeterPage } from '../export-meter/export-meter';
import { TranslateService } from '@ngx-translate/core';
import { ToastProvider } from '../../providers/toast/toast';


@IonicPage()
@Component({
  selector: 'page-meter',
  templateUrl: 'meter.html',
})
export class MeterPage {

	meterReading = MeterReadingPage;
	consumptionChart = ConsumptionChartPage;
  active = null;
  index = 0;

  meterResponse : any

  constructor(public navCtrl: NavController,private translate: TranslateService, public navParams: NavParams, private meterProvider: MeterProvider,
    private alertCtrl : AlertController,
    private toast: ToastProvider,
    ) {
    if(navParams.get("index")){
      this.index = navParams.get("index");
    }

  
  this.getMeterStatusResponse()

  }

  downloadExcel(){
    this.navCtrl.push(ExportMeterPage, {
      parent: this,
    });
  }


  getMeterStatusResponse (){
    this.meterProvider.getMeterActivesResponse().then(val=> {
      console.log(val,"response")
      if(val.status =="success"){
      this.meterResponse = val.data 
      if(this.meterResponse.date_time){
        this.meterResponse.date_time =  new Date(this.meterResponse.date_time).getDate() +` / `+ (new Date(this.meterResponse.date_time).getMonth()+1) +` / `+ new Date(this.meterResponse.date_time).getFullYear()
      }
      this.meterResponse.keysArr = Object.keys(this.meterResponse);
      this.toast.presentToast(val.data.remarks? val.data.remarks : 'Success' );
      }else{
        this.toast.presentToast(val.message);

      }
    })
  }


  openPopUpLiveResponse(){
    var dynamicList =""
    this.meterResponse.keysArr.forEach((val)=>{
        dynamicList += `<ion-item no-lines transparent > <ion-icon icon-medium name="speedometer" item-start></ion-icon><h2 subitem-title> <span class="list__right_col"> ${val.replace("_"," ")} : </span> <span class="list__value"> ${this.meterResponse[val] ?  this.meterResponse[val] : '-' } </span> </h2></ion-item>`
    })

    let alert = this.alertCtrl.create({
      title: 'Live Response',
      cssClass: 'status__alert__live__reading',
		  message : ` <div class="list__box"><ion-row><ion-col col-12 text-left margin-top> ${dynamicList} </ion-col> </ion-row> </div>`,
		  buttons: [
			{
			  text: 'ok',
			  role: 'cancel',
			  handler: data => {
			  }
			}
		  ]
		});
		alert.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MeterPage');
  }

}





// WEBPACK FOOTER //
// ./src/pages/meter/meter.ts